module.exports = __webpack_public_path__ + "images/emoji/clock430.3c83175c708811ded9ad.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock430.png
// module id = l0X2
// module chunks = 13